import { render, staticRenderFns } from "./product-selector.vue?vue&type=template&id=117a48cd"
import script from "./product-selector.vue?vue&type=script&lang=js"
export * from "./product-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117a48cd')) {
      api.createRecord('117a48cd', component.options)
    } else {
      api.reload('117a48cd', component.options)
    }
    module.hot.accept("./product-selector.vue?vue&type=template&id=117a48cd", function () {
      api.rerender('117a48cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selector/product-selector.vue"
export default component.exports